import {
    AngleType,
    AttributesPrices,
    AttrItemType, BoxMaterialColorType, ClosetAccessoriesTypes, CustomPartType, CustomTypes,
    DoorColorType, FinishSidesTypes, GlassAndMirrorTypes, GlassNamesTypes, hingeTypes, JeweleryInsertsType,
    materialDataType, MaybeEmpty,
    MaybeNull,
    MaybeUndefined, MechanismType,
    priceItem,
    pricePart, priceStandardPanel,
    pricesTypings, pricesTypingsNumber,
    productCategory,
    productDataToCalculatePriceType, ProductExtraType, ProductOptionsType, ProductOptionsTypes,
    productRangeType,
    ProductType,
    productTypings,
    sizeLimitsType,
    valueItemType
} from "./productTypes";
import settings from './../api/settings.json'
import {
    checkDoors,
    convertDoorAccessories,
    getAttributes,
    getCabinetHeightRangeBasedOnCategory, getDoorHeight,
    getFinishColorCoefCustomPart,
    getIsCloset,
    getIsLeatherCloset,
    getIsLeatherOrRTAorSystemCloset,
    getIsLeatherOrSystemCloset,
    getIsRTAorSystemCloset,
    getIsSystemCloset,
    getLedHeight,
    getLEDProductCartPrice,
    getLedWidth,
    getProductById,
    getSquare,
    getWidthToCalculateDoor,
    hasGlassShelfColor,
    isHingeHolesBlock,
    isPanelCutoutBlock, notNegative,
} from "./helpers";
import {productChangeMaterialType,} from "../store/reducers/generalSlice";
import standardProductsPrices from '../api/standartProductsPrices.json'
import productPrices from '../api/prices.json'
import ro_drawer_prices from '../api/ro_drawer_prices.json'
import sizes from './../api/sizes.json'
import {DoorTypesType, FinishTypes, RodType, RoomCategoriesType, RoomMaterialsFormType} from "./roomTypes";
import {CartAPI, CartCustomTypeAPI, CartItemFrontType, CartLEDAPI, StandardDoorAPIType} from "./cartTypes";
import {
    DoorAccessoryAPIType, DrawerInserts, DrawerROType, GrooveAPIType,
    RTAClosetAPIType
} from "../Components/CustomPart/CustomPart";
import {PanelsFormAPIType} from "../Components/CustomPart/CustomPartStandardPanel";
import {BoxMaterialType} from "./roomTypes";
import {CustomPartDoublePanel, CustomPartDoublePanelType} from "./Enums";


// собираем уникальные значения
export const getAllowedValues = (data: pricePart[], key: keyof pricePart): number[] => {
    return [...new Set(
        data
            .map(el => el[key])
            .filter((v): v is number => typeof v === 'number')
    )].sort((a, b) => a - b);
};

// логика округления
const normalizeValue = (value: number, allowed: number[]): number => {
    for (let i = 0; i < allowed.length; i++) {
        const current = allowed[i];
        const next = allowed[i + 1];
        const delta = next ? next - current : Infinity;
        const threshold = delta > 1 ? 1 : 0.95;

        if (value <= current + threshold) {
            return current;
        }
    }
    return allowed[allowed.length - 1];
};

export const getTablePrice = (width: number, height: number, depth: number, priceData: pricePart[]): number => {
    if (!priceData.length) return 0;

    const hasHeight = priceData.some(el => el.height !== undefined);
    const hasDepth = priceData.some(el => el.depth !== undefined);

    const widths = getAllowedValues(priceData, 'width');
    const heights = hasHeight ? getAllowedValues(priceData, 'height') : [];
    const depths = hasDepth ? getAllowedValues(priceData, 'depth') : [];


    const normWidth = normalizeValue(width, widths);

    const normHeight =
        hasHeight && height !== 0
            ? normalizeValue(height, heights)
            : undefined;

    const normDepth =
        hasDepth && depth !== 0
            ? normalizeValue(depth, depths)
            : undefined;

    const found = priceData.find(el => {
        if (el.width !== normWidth) return false;

        if (hasHeight && height !== 0 && el.height !== normHeight) return false;
        if (hasDepth && depth !== 0 && el.depth !== normDepth) return false;

        return true;
    });

    return found?.price ?? 0;
};

function getStartPrice(tablePrice: number, materialData: materialDataType, options: string[]): number {
    const {box_material_coef, box_material_finish_coef, grain_coef, materials_coef} = materialData;
    const boxCoef = options.includes("Box from finish material") ? box_material_finish_coef : box_material_coef;
    console.log(`boxCoef ${boxCoef}`)
    console.log(`grain_coef ${grain_coef}`)
    const totalCoef = +(boxCoef * materials_coef * grain_coef).toFixed(3);
    return +(tablePrice * totalCoef).toFixed(1)
}

export function addWidthPriceCoef(width: number, maxWidth: number) {
    return Math.ceil((width - maxWidth - 1) / 3) / 10;
}

export function addHeightPriceCoef(customHeight: number, maxHeight: number) {
    return Math.ceil((customHeight - maxHeight - 1) / 3) / 10
}

export function addDepthPriceCoef(customDepth: number, depthRangeData: number[], isAngle: MaybeUndefined<AngleType>) {
    if (isAngle) return 0;
    const maxDepth = depthRangeData[depthRangeData.length - 1];
    if (customDepth > maxDepth) return Math.ceil((customDepth - maxDepth - 1) / 3) / 10;
    return 0
}

function addPTODoorsPrice(hinge_opening: hingeTypes, id: number, category: MaybeEmpty<RoomCategoriesType>, width: number): number {
    let doorQty = checkDoors(hinge_opening);

    // Stationary door qty
    if ([105, 108].includes(id)) doorQty = 1;

    // No doors in System Closet (only Glass door option)
    if (getIsLeatherOrSystemCloset(category)) {
        doorQty = width >= 24 ? 2 : 1;
    }
    return doorQty && settings.fixPrices["PTO for doors"] ? +doorQty * settings.fixPrices["PTO for doors"] : 0;
}

export function addPTODrawerPrice(prodType: productTypings, drawersQty: number): number {
    return drawersQty && settings.fixPrices["PTO for drawers"] ? +drawersQty * settings.fixPrices["PTO for drawers"] : 0;
}

export function addPTOTrashBinsPrice(): number {
    return settings.fixPrices['Servo-Drive'] || 0
}

export function addGlassDoorPrice(square: number, profileName: MaybeUndefined<string>, is_standard: boolean, hasGlassDoor: boolean): number {
    if (!hasGlassDoor) return 0;
    if (is_standard) return square * settings.standard_glass_door_price;

    const profileType = settings.Glass.Profile.find(el => el.value === profileName)?.type;
    const minPrice = settings.Glass.priceType.find(el => el.id === profileType)?.minPrice;
    const multiplier = settings.Glass.priceType.find(el => el.id === profileType)?.multiplier;
    if (!minPrice || !multiplier) return 0;
    const p = square * multiplier;
    return p > minPrice ? p : minPrice
}

export const addGlassAndMirroredShelfPrice = (area: number, glassShelf: MaybeUndefined<MaybeEmpty<GlassAndMirrorTypes | GlassNamesTypes>>): number => {
    // Min price area
    const areaForPrice = area >= 3 ? area : 3;
    switch (glassShelf) {
        case "Clear Glass":
        case 'Clear':
            return areaForPrice * 25.5;
        case "Bronze Glass":
        case "Gray Glass":
        case "Clear Mirror":
        case 'Bronze':
        case 'Gray':
            return areaForPrice * 45;
        case "Frosted Glass":
        case "Bronze Mirror":
        case "Gray Mirror":
        case 'Frosted':
            return areaForPrice * 57;
    }
    return 0
}

export const resolveTypeByDimensions = (
    attributes: AttrItemType[],
    width: number,
    height: number
): productTypings => {
    let common: Set<productTypings> | null = null;

    for (const attr of attributes) {
        const filtered = (attr.values ?? []).filter(v => {
            // ❗ value = 0 → не влияет
            if (v.value === 0) return false;

            // max включительно
            if (v.maxWidth !== undefined && width > v.maxWidth) return false;
            if (v.maxHeight !== undefined && height >= v.maxHeight) return false;

            // min строго
            if (v.minWidth !== undefined && width <= v.minWidth) return false;
            if (v.minHeight !== undefined && height < v.minHeight) return false;

            return true;
        });

        const types = filtered.map(v => v.type);

        // 👉 если после фильтра ничего не осталось — атрибут не влияет
        if (!types.length) continue;

        const current = new Set(types);

        if (common === null) {
            common = current;
            continue;
        }

        // пересечение
        common = new Set([...common].filter(t => current.has(t)));

        if (common.size === 0) return 1;
    }

    return [...(common ?? [])][0] ?? 1;
};

export const getProductFrontCustomVal = (custom: MaybeNull<ProductExtraType>): MaybeUndefined<CartCustomTypeAPI> => {
    return custom ? {
        accessories: custom.closet_accessories ? {closet: custom.closet_accessories} : undefined,
        jewelery_inserts: custom.jewelery_inserts?.length ? custom.jewelery_inserts : undefined,
        mechanism: custom.mechanism,
        extra_rollouts: custom.extra_rollouts
    } : undefined
}

export function getDoorMinMaxValuesArr(realWidth: number, doorValues?: valueItemType[], widthDivider?: number): MaybeNull<number[]> {
    if (!doorValues) return null;
    const filterDoorArr = (width: number, doorValues?: valueItemType[]): valueItemType[] => {
        if (!doorValues) return [];
        if (doorValues.length === 1) return doorValues;
        return doorValues.filter(val => {
            const maxWidth = val.maxWidth;
            const minWidth = val.minWidth;
            if (maxWidth && width >= maxWidth) return false;
            if (minWidth && width < minWidth) return false;
            return true;
        });
    }
    if (widthDivider && doorValues.length >= 2) return realWidth <= widthDivider ? [doorValues[0].value] : [doorValues[1].value];
    const filter = filterDoorArr(realWidth, doorValues)
    return [...new Set<number>(filter.map(el => el.value))]
}

function getPvcPrice(doorWidth: number, doorHeight: number, product: ProductType, materialData: materialDataType): number {
    const {horizontal_line = 2, product_type} = product
    const {
        door_finish_material,
        door_type,
        category
    } = materialData;
    if (door_type === 'No Doors' || door_finish_material === 'Milino' || product_type === 'standard' || getIsLeatherOrRTAorSystemCloset(category) || door_type === 'Wood ribbed doors') return 0;
    const per = (horizontal_line * doorWidth + doorHeight * 2) / 12;
    let coef = 2.5;
    if (door_type === 'Custom Painted') coef = 2.75;
    if (['Ultrapan Acrylic', 'Wood Veneer', 'StyleLite'].includes(door_finish_material)) coef = 2.75;
    return +(per * coef).toFixed(2);
}

function getDoorPrice(square: number, materialData: materialDataType): number {
    const {
        door_price_multiplier,
        category,
        box_material,
        box_color,
    } = materialData;
    if (getIsLeatherOrRTAorSystemCloset(category)) {
        const oldMultiplier = chooseDoorPanelMultiplier("Slab", box_material, box_color);
        const diffMultiplier = notNegative(door_price_multiplier - oldMultiplier)
        return +(square * diffMultiplier).toFixed(1);
    }
    return +(square * door_price_multiplier).toFixed(1);
}

function chooseDoorPanelMultiplier(door_type: string, material: string, color: string): number {
    switch (door_type) {
        case "Slab":
            switch (material) {
                case 'Milino': {
                    const colorType = getDoorColorType(color);
                    if (colorType === 1) return 8;
                    if (colorType === 2) return 8.8;
                    if (colorType === 3) return 9.6;
                    break;
                }
                case "Syncron":
                case "Finsa":
                    return 18;
                case 'Luxe':
                case 'Ultrapan PET':
                    return 24;
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                    return 24.72;
                case "Ultrapan Acrylic":
                    return 26.4;
            }
            break;
        case "Five Piece Shaker":
            if (material === "Syncron" || material === 'Finsa') return 48;
            return 61.8;
        case "Custom Painted":
            return 78;
        case "Shaker":
            return 60;
        case "Slatted":
            return 48;
    }
    return 0;
}

function getPanelPrice(square: number, material: MaybeUndefined<string>): number {
    const k = square > 1 ? 1 : 1.8;
    switch (material) {
        case "Milino":
            return square * k * 8;
        case "Plywood":
            return square * k * 10;
        case "Syncron":
        case "Finsa":
            return square * k * 18;
        case "Luxe":
        case "Ultrapan PET":
            return square * k * 24;
        case "Ultrapan Acrylic":
            return square * k * 24 * 1.1;
        case "Zenit":
        case "OneSkin":
        case "Egger":
        case "Cleaf":
            return square * k * 24 * 1.03;
        case "Painted":
            return square * k * 44.62;
        case "Wood Veneer":
        case "StyleLite":
            return square * k * 46.2;
        default:
            return 0;
    }
}

function getShakerPanelPrice(square: number, door_finish_material: MaybeUndefined<string>): number {
    switch (door_finish_material) {
        case "Milino":
            return square * 48;
        case "Luxe":
        case "Syncron":
        case "Ultrapan PET":
        case "Finsa":
            return square * 60;
        case "Ultrapan Acrylic":
            return square * 60 * 1.1;
        case "Zenit":
        case "OneSkin":
        case "Egger":
        case "Cleaf":
            return square * 60 * 1.03;
        case 'Painted':
            return square * 85.8;
        case "Wood Veneer":
        case "StyleLite":
            return square * 96 * 1.1 * 1.1;
        default:
            return 0;
    }
}

function getSlattedPanelPrice(square: number, material: MaybeUndefined<string>): number {
    if (!material) return 0;
    if (material === 'Milino') return square * 48;
    return square * 60;
}

function getDrawerPrice(qty: number, width: number, door_type: string, drawerBrand: string, drawerType: string, drawerColor: string): number {
    const isStandardCabinet = door_type === 'Standard Size Shaker'

    if (!qty) return 0;

    switch (drawerBrand) {
        case 'Milino':
            switch (drawerType) {
                case 'Same as Box Material':
                    return isStandardCabinet ? qty * 10 : qty * 15;
                case 'Legrabox':
                    if (drawerColor === 'LED') {
                        return qty * 150;
                    }
                    return !isStandardCabinet ? qty * 33 : 0;
                case 'Dovetail':
                    if (drawerColor === 'Maple') return qty * (width * 2 + 25);
                    if (drawerColor === 'Walnut') return qty * (width * 2 + 45);
                    break;
            }
            break
        case 'BLUM':
            switch (drawerType) {
                case 'Same as Box Material':
                    return qty * 60;
                case 'Legrabox':
                    if (drawerColor === 'Orion Gray') return qty * 170;
                    if (drawerColor === 'Stainless Steel') return qty * 220;
                    break;
                case 'Dovetail':
                    if (drawerColor === 'Maple') return qty * (width * 2 + 70);
                    if (drawerColor === 'Walnut') return qty * (width * 2 + 90);
                    break;
            }
            break;
    }
    return 0
}

function getClosetAccessoriesPrice(closet_accessories: MaybeUndefined<ClosetAccessoriesTypes>, width: number): number {
    if (!closet_accessories) return 0;
    switch (closet_accessories) {
        case "Belt Rack":
            return 100;
        case "Tie Rack":
            return 120;
        case "Valet Rod":
            return 80;
        case "Pant Rack":
            if (width <= 18) return 280;
            if (width <= 24) return 300;
            if (width <= 30) return 350;
    }
    return 0
}

export function getJeweleryInsertsPrice(jewelery_inserts: MaybeUndefined<JeweleryInsertsType[]>): number {
    if (!jewelery_inserts) return 0;
    return jewelery_inserts.length * 100;
}

export function getMechanismPrice(mechanism: MaybeUndefined<string>, hasMechanism: MaybeUndefined<MechanismType>): number {
    if (!mechanism || !hasMechanism) return 0;
    return hasMechanism.attributes.find(el => el.name === mechanism)?.price ?? 0;
}

export const getRodPrice = (room_category: MaybeEmpty<RoomCategoriesType>, width: number, rod: MaybeEmpty<RodType>, qty: number): number => {
    if (!getIsCloset(room_category) || rod === 'Oval Chrome (Default)') return 0;
    return 3 * width * qty;
}

export const getExtraRolloutsPrice = (hasBlock: MaybeUndefined<boolean>, cart: CartAPI, materialData: materialDataType): number => {
    const {custom, width} = cart
    if (!hasBlock || !custom?.extra_rollouts) return 0;
    const {base_price_type, door_type, drawer_type, drawer_brand, drawer_color} = materialData
    // Get price for custom part 'Extra RO drawer'
    const ro_drawer = "Extra RO";
    const tablePrice = getRoDrawerTablePrice(width, base_price_type, ro_drawer);
    const startPrice = getStartPrice(tablePrice, materialData, [])
    const drawerPrice = getDrawerPrice(1, width, door_type, drawer_brand, drawer_type, drawer_color);
    const rolloutPrice = startPrice + drawerPrice;
    return custom.extra_rollouts * rolloutPrice;
}
// const isPositive = (n:number):boolean => n > 0;
export const getFinishSidesPrice = (finish_sides: FinishSidesTypes[], width: number, height: number, depth: number, material: string): number => {
    const calcMap: Record<string, number> = {
        Left: (height * depth) / 144,
        Right: (height * depth) / 144,
        Bottom: (width * depth) / 144,
    };

    const sq = finish_sides.reduce((sum, side) => {
        return sum + (calcMap[side] || 0);
    }, 0);

    return getPanelPrice(sq, material)
}

function getWidthRange(priceData: MaybeUndefined<pricePart[]>): number[] {
    if (!priceData) return [];
    return getAllowedValues(priceData, 'width')
}

export function getHeightRange(priceData: MaybeUndefined<pricePart[]>, category: productCategory, customHeight: MaybeUndefined<number>): number[] {
    if (customHeight) return [customHeight];
    if (priceData && priceData.find((el) => el.height)) {
        return getAllowedValues(priceData, 'height')
    }
    return getCabinetHeightRangeBasedOnCategory(category)
}

function getDepthRange(priceData: pricePart[] | undefined, category: productCategory, customDepth: number | undefined): number[] {
    if (customDepth) return [customDepth];
    if (priceData && priceData.find((el) => el.depth)) {
        return getAllowedValues(priceData, 'depth')
    }
    switch (category) {
        case "Base Cabinets":
        case "Tall Cabinets":
        case "Gola Base Cabinets":
        case "Gola Tall Cabinets":
        case "Standard Base Cabinets":
        case "Standard Tall Cabinets":
            return [24];
        case "Wall Cabinets":
        case "Gola Wall Cabinets":
        case "Standard Wall Cabinets":
        case "Standard Gola Wall Cabinets":
            return [13];
        case "Vanities":
        case "Floating Vanities":
        case "Gola Floating Vanities":
        case "Standard Vanities":
        case "Standard Floating Vanities":
            return [21];
        case "Build In":
            return [23]
        case "Leather":
            return [15.5]
        default:
            return []
    }
}

function getLedPrice(width: number, height: number, led: MaybeUndefined<CartLEDAPI>): number {
    if (!led) return 0;
    const {border} = led;
    let length: number = 0;

    if (border.includes('LED Panel')) return height * 2.55;
    if (border.includes('LED Shelf')) return (width) * 2.55;

    if (border.includes('Sides')) length = height * 2
    if (border.includes('Top')) length += (width - 1.5)
    if (border.includes('Bottom')) length += (width - 1.5)
    if (border.includes('Bottom Inside')) length += (width - 1.5)
    if (border.includes('Bottom Outside')) length += (width - 1.5)
    return +(length * 2.55).toFixed(1);
}

const getBasePriceType = (materials: RoomMaterialsFormType): pricesTypings => {
    const {door_type, door_color, door_finish_material, box_material, category} = materials;
    if (!category) return 3;
    if (['Wood Veneer', 'StyleLite'].includes(box_material)) return "wood_veneer";
    switch (category as RoomCategoriesType) {
        case "Leather Closet":
        case "RTA Closet":
        case "Cabinet System Closet": {
            if (box_material === 'Milino') return 1;
            if (box_material === 'Syncron') return 2;
            return 3
        }
        case "Kitchen":
        case "Vanity":
        case "Build In Closet": {
            if (!box_material || !door_type) return 1;
            switch (door_type as DoorTypesType) {
                case 'Slab':
                    if (!door_finish_material) return 3;
                    switch (door_finish_material) {
                        case 'Milino':
                            const colorType = getDoorColorType(door_color);
                            if (colorType === 1 || colorType === 2) return 1;
                            return 2;
                        case 'Syncron':
                        case 'Finsa':
                            return 2;
                    }
                    break;
                case 'No Doors':
                    return 1;
                case 'Five Piece Shaker':
                case 'Three Piece Door':
                case 'Finger Pull':
                    if (door_finish_material === 'Syncron' || door_finish_material === 'Finsa') return 2;
                    break;
                case 'Shaker':
                case 'Slatted':
                    if (door_finish_material === 'Milino') return 2;
                    break;
                case "Wood ribbed doors":
                    return 1;
                case "Custom Painted":
                    if (door_finish_material === 'Slab') return 2;
                    return 3
            }
            return 3;
        }
    }
}

const getMaterialCoef = (materials: RoomMaterialsFormType): number => {
    const {door_type, door_finish_material, door_color, box_material, category} = materials;
    if (!door_type || !box_material || !category) return 1;
    switch (category as RoomCategoriesType) {
        case "Kitchen":
        case "Vanity":
        case "Build In Closet": {
            switch (door_type as DoorTypesType) {
                case 'Slab':
                    if (!door_finish_material) return 1;
                    switch (door_finish_material) {
                        case 'Milino':
                            return getDoorColorType(door_color) === 2 ? 1.05 : 1;
                        case 'Zenit':
                        case "OneSkin":
                        case "Egger":
                        case "Cleaf":
                            return 1.03;
                        case 'Ultrapan Acrylic':
                        case "StyleLite":
                        case "Wood Veneer":
                            return 1.1;
                    }
                    break;
                case 'Finger Pull':
                case 'Five Piece Shaker':
                    switch (door_finish_material) {
                        case 'Zenit':
                        case "OneSkin":
                        case "Egger":
                        case "Cleaf":
                            return 1.03;
                    }
                    break;
                case 'Custom Painted':
                    return 1.05 * 1.1;
                case 'Shaker':
                    switch (door_finish_material) {
                        case 'Zenit':
                        case "OneSkin":
                        case "Egger":
                        case "Cleaf":
                            return 1.03;
                        case 'Ultrapan Acrylic':
                        case "StyleLite":
                        case "Wood Veneer":
                            return 1.1;
                    }
                    break;
                case 'Slatted':
                    return 1.03;
                case "Wood ribbed doors":
                    return 1;
            }
            break
        }
    }
    return 1
}

const getGrainCoef = (doorGrain: string): number => {
    return !doorGrain || doorGrain === 'Vertical' ? 1 : 1.1
}

export const isTexturedColor = (color: string): boolean => {
    // New Textured colors
    return ['Desert Oak', 'White Oak', 'Brown Oak', 'Glacier Oak', 'Grey Woodline', 'Ivory Woodline', 'Sable Wood', 'White Gloss'].includes(color)
}

const getDoorColorType = (color: string): DoorColorType => {
    if (color.includes('Melamine')) return 1;
    if (isTexturedColor(color)) return 2;
    if (color.includes('Ultra Matte')) return 3;
    return 1
};

export const getBoxMaterialColorType = (color: string): BoxMaterialColorType => {
    if (color.includes('Melamine')) return 1;
    if (isTexturedColor(color)) return 2;
    if (color.includes('Ultra Matte')) return 3;
    if (color.includes('Plywood')) return 4;
    return 1
};

export const getBoxMaterialCoefByColorType = (box_color_type: BoxMaterialColorType): number => {
    switch (box_color_type) {
        case 1:
            return 1;
        case 2:
            return 1.1
        case 3:
            return 1.2
        case 4:
            return 1.15
    }
    return 1;
}

const getBoxMaterialCoef = (box_material: MaybeEmpty<BoxMaterialType>, box_color: string, product_id: number): number => {
    // Exceptions
    const noCoefExceptionsArr: number[] = [35];
    if (noCoefExceptionsArr.includes(product_id) || !box_material) return 1;
    switch (box_material) {
        case "Natural Plywood":
        case "White Plywood":
        case "Gray Plywood":
            return 1.15;
        case "White Melamine":
        case "Gray Melamine":
        case "Ash Melamine":
        case "Beige Linen Melamine":
        case "Gray Linen Melamine":
        case "Walnut Melamine":
            return 1
        case "Brown Oak":
        case "Glacier Oak":
        case "Desert Oak":
        case "White Oak":
        case "Grey Woodline":
        case "Ivory Woodline":
        case "Sable Wood":
        case "White Gloss":
            return 1.1
        case "Ultra Matte Grey":
        case "Ultra Matte White":
        case "Ultra Matte Cashmere":
        case "Ultra Matte Gris":
        case "Ultra Matte Volcano":
            return 1.2;


        // Leather, RTA and System
        case 'Milino': {
            const boxColorType = getBoxMaterialColorType(box_color)
            return getBoxMaterialCoefByColorType(boxColorType);
        }
        case 'Zenit':
        case "OneSkin":
        case "Egger":
        case "Cleaf":
            return 1.03;
        case 'Ultrapan Acrylic':
            return 1.1;
    }
    return 1;
}

const getBoxMaterialFinishCoef = (door_finish_material: string, door_color: string): number => {
    switch (door_finish_material) {
        case "Milino":
            const colorType = getDoorColorType(door_color);
            if (colorType === 1) return 1;
            if (colorType === 2) return 1.1;
            return 1.2
        case "Syncron":
        case "Finsa":
            return 1.845
        default:
            return 2.706
    }
}
const getDoorPriceMultiplier = (materials: RoomMaterialsFormType, is_standard_room: boolean): number => {
    const {door_type, door_finish_material, door_color, category} = materials
    if (is_standard_room) return door_color === 'Default White' ? 0 : 30;
    switch (category as RoomCategoriesType) {
        case "Kitchen":
        case "Vanity":
        case "Build In Closet": {
            if (!door_type) return 0;
            switch (door_type as DoorTypesType) {
                case "Slab":
                    if (['Wood Veneer', 'StyleLite'].includes(door_finish_material)) return 24.2;
                    return 0;
                case "No Doors":
                    return -8;
                case "Five Piece Shaker":
                case "Three Piece Door":
                case "Finger Pull":
                    if (door_finish_material === 'Syncron' || door_finish_material === 'Finsa') return 30;
                    return 36;
                case "Custom Painted":
                    if (door_finish_material === 'Slab') return 33;
                    return 47.52;
                case "Shaker":
                    switch (door_finish_material as FinishTypes) {
                        case "Milino":
                            return 30;
                        case "Wood Veneer":
                        case "StyleLite":
                            return 36 + 22 * 1.1
                        default:
                            return 36;
                    }
                case "Slatted":
                    if (door_finish_material === 'Milino') return 31.5;
                    return 37.8;
                case "Wood ribbed doors": {
                    const finish = door_finish_material as FinishTypes;
                    const extra = finish.includes('Clear Coat') ? settings.fixPrices.clear_coat : 0;
                    if (finish.includes('Maple') || finish.includes('Birch')) return 145 + extra;
                    if (finish.includes('White Oak') || finish.includes('Walnut')) return 225 + extra;
                }
            }
            return 0;
        }
        case "Leather Closet":
        case "RTA Closet":
        case "Cabinet System Closet": {
            return chooseDoorPanelMultiplier(door_type, door_finish_material, door_color);
        }
    }
}
export const getProductRange = (priceData: MaybeUndefined<pricePart[]>, category: productCategory, customHeight: MaybeUndefined<number>, customDepth: MaybeUndefined<number>): productRangeType => {
    return {
        widthRange: getWidthRange(priceData),
        heightRange: getHeightRange(priceData, category, customHeight),
        depthRange: getDepthRange(priceData, category, customDepth)
    }
}

export const getSizeLimitsFromData = (product_id: number, isAngle: MaybeUndefined<AngleType>): MaybeUndefined<sizeLimitsType> => {
    let limits = sizes.find(size => size.productIds.includes(product_id))?.limits;
    if (limits && isAngle) limits = {...limits, depth: limits?.width};
    return limits
}

export const getMaterialData = (materials: RoomMaterialsFormType, product_id: number): materialDataType => {
    const {
        door_type,
        door_grain,
        door_finish_material,
        door_color,
        box_material,
        box_color,
    } = materials;
    const is_standard_room = door_type === "Standard Size Shaker";
    const base_price_type = getBasePriceType(materials);
    const materials_coef = getMaterialCoef(materials);
    const grain_coef = getGrainCoef(door_grain);
    const box_material_coef = getBoxMaterialCoef(box_material, box_color, product_id);
    const box_material_finish_coef = getBoxMaterialFinishCoef(door_finish_material, door_color);
    const door_price_multiplier = getDoorPriceMultiplier(materials, is_standard_room);
    return {
        ...materials,
        is_standard_room,
        base_price_type,
        grain_coef,
        box_material_coef,
        box_material_finish_coef,
        door_price_multiplier,
        materials_coef
    }
}

const filterByOptionsType = (options: string[]): ProductOptionsType[] => {
    return options.filter(
        (value): value is ProductOptionsType =>
            ProductOptionsTypes.includes(value as ProductOptionsType)
    );
}

const filterProductOptionsBasedOnMaterialData = (options: ProductOptionsType[], materials: RoomMaterialsFormType): ProductOptionsType[] => {
    const {door_type, drawer_brand} = materials;
    let arr = filterByOptionsType(options);


    if (drawer_brand === 'Milino') arr = arr.filter(o => o !== 'PTO for drawers');
    if (door_type === "Standard Size Shaker") arr = arr.filter(o => o === 'PTO for doors' || o === 'Glass Door');
    return arr;
}

export const getProductDataToCalculatePrice = (product: ProductType | productChangeMaterialType, materials: RoomMaterialsFormType, image_active_number: productTypings = 1): productDataToCalculatePriceType => {
    const {attributes, options} = product;
    const attrArr = getAttributes(attributes, image_active_number);
    const doorValues = attributes.find(el => el.name === 'Door')?.values;

    const drawersQty = attrArr.reduce((acc, current) => {
        const qty = current.name.includes('Drawer') ? current.value : 0
        return acc + qty;
    }, 0);

    const rolloutsQty = attrArr.reduce((acc, current) => {
        const qty = current.name.includes('Rollout') ? current.value : 0
        return acc + qty;
    }, 0);
    const filteredOptions = filterProductOptionsBasedOnMaterialData(options, materials)
    const shelfsQty = attrArr.reduce((acc, current) => {
        const qty = current.name.includes('Shelf') ? current.value : 0
        return acc + qty;
    }, 0);
    const rodsQty = getRodsQty(attrArr)
    return {
        doorValues,
        drawersQty: drawersQty + rolloutsQty,
        filteredOptions,
        shelfsQty,
        rodsQty
    }
}
export const getProductPriceRange = (id: number, materialData: materialDataType): MaybeUndefined<pricePart[]> => {
    const {is_standard_room, base_price_type} = materialData
    if (is_standard_room) {
        const data = standardProductsPrices.find(el => el.id === id)?.prices;
        if (data && data.length) return data;
    }
    const data = productPrices.find(el => el.id === id)?.prices as MaybeUndefined<priceItem[]>;
    if (!data) return undefined;
    if (base_price_type === 'wood_veneer') {
        const maxData = data.find(i => i.type === 3)?.data
        const minData = data.find(i => i.type === 1)?.data
        if (!minData || !maxData) return undefined;
        return minData.map((el, index) => ({...el, price: maxData[index].price * 2 - el.price}))
    }
    return data.find(i => i.type === base_price_type)?.data;
}

const getCustomPriceAdditions = (product: CustomPartType, values: CartAPI, customPartPrice: number): number => {
    const {id} = product
    const {width, height, led} = values
    const hingeHolesPrice = getHingeHolesPrice(id, values);
    const panelCutoutPrice = getPanelCutoutPrice(id, values, customPartPrice);
    const ledPrice = getLedPrice(width, height, led);
    // Possible to add extra additions here
    const additionsPrice = hingeHolesPrice + panelCutoutPrice + ledPrice;
    return additionsPrice
}

const getHingeHolesPrice = (id: number, values: CartAPI): number => {
    if (!isHingeHolesBlock(id)) return 0;
    const {custom} = values;
    if (!custom || !custom.panel_accessories?.hinges_or_holes?.type) return 0;
    return custom.panel_accessories.hinges_or_holes.type === 'Hinges' ? 32 : 12
}

const getPanelCutoutPrice = (id: number, values: CartAPI, custom_part_price: number): number => {
    if (!isPanelCutoutBlock(id)) return 0;
    const {custom} = values;
    if (!custom || !custom.panel_accessories?.cutout) return 0;
    return custom_part_price / 2
}

const minAvailableArea = (area: number, minArea: number): number => {
    return Math.max(area, minArea);
}

export const getCustomPartPrice = (product: CustomPartType, materials: RoomMaterialsFormType, values: CartAPI): number => {
    let price: number = 0;
    const {width, height, depth, custom, glass, product_id, led} = values;
    const {door_color, door_type, box_color, category} = materials
    const {id, type} = product;
    let area = +(width * height / 144).toFixed(2);
    const color = getIsRTAorSystemCloset(category) ? box_color : door_color;
    switch (id) {
        case 900: {
            switch (custom?.material) {
                case "Milino":
                    price = (width * height * depth / 100) + 120;
                    break;
                case "Plywood":
                    price = (width * height * depth / 80) + 120;
                    break;
                case "Syncron":
                case "Finsa":
                    price = (width * height * depth / 50) + 120;
                    break;
                case "Luxe":
                case "Ultrapan PET":
                    price = (width * height * depth / 20) + 120;
                    break;
                case "Ultrapan Acrylic":
                    price = ((width * height * depth / 20) + 120) * 1.1;
                    break;
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                    price = ((width * height * depth / 20) + 120) * 1.03;
                    break;
                case "Painted":
                    price = ((width * height * depth / 20) * 1.3 + 156) * 1.05 * 1.1;
                    break;
                case "Wood Veneer":
                case "StyleLite":
                    price = ((width * height * depth / 10) + 120) * 1.1;
                    break;
            }
            const shelves = custom?.shelves;
            if (shelves) {
                const {qty, color, index} = shelves
                const sq = (width - 1.5) * (depth - 0.75) / 144;
                const shelfsPrice = (hasGlassShelfColor(index) ? addGlassAndMirroredShelfPrice(sq, color) : getPanelPrice(sq, custom?.material)) * qty;
                price += shelfsPrice;
            }
            if (led?.border.length) {
                price += getLedPrice(width, height, led);
            }
            break;
        }
        case 901: {
            const shelfCoef = (width * height + width * depth + height * depth) / 144 * 2 * 2.3
            let materialCoef = 0;
            switch (custom?.material) {
                case "Milino":
                    materialCoef = 20;
                    break;
                case "Syncron":
                case "Finsa":
                    materialCoef = 22;
                    break;
                case "Luxe":
                case "Ultrapan PET":
                    materialCoef = 24;
                    break;
                case "Ultrapan Acrylic":
                    materialCoef = 24 * 1.1;
                    break;
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                    materialCoef = 24 * 1.03;
                    break;
                case "Painted":
                    materialCoef = 31.2 * 1.05 * 1.1;
                    break;
                case "Wood Veneer":
                case "StyleLite":
                    materialCoef = 37.4;
                    break;
            }
            const ledPrice = getLedPrice(width - 1.5, height, led);
            price = shelfCoef * materialCoef + ledPrice;
            break;
        }
        case 903: {
            const panel = getPanelPrice(area, custom?.material);
            const finishColorCoef = getFinishColorCoefCustomPart(id, custom?.material, color);
            const finishedColorPrice = panel * finishColorCoef;
            const additions = getCustomPriceAdditions(product, values, finishedColorPrice);
            price = finishedColorPrice + additions;
            break;
        }
        case 904: {
            const panel = getPanelPrice(area, custom?.material);
            const finishColorCoef = getFinishColorCoefCustomPart(id, custom?.material, color);
            price = panel * finishColorCoef;
            break;
        }
        case 905: {
            area = minAvailableArea(area, 1);
            const double_panel = custom?.panel_accessories?.double_panel;
            let typeCoef = 1;
            let materialCoef = 0;
            if (double_panel) {
                switch (double_panel) {
                    case 0:
                        typeCoef = 1;
                        break;
                    case 1:
                        typeCoef = 0.65;
                        break;
                    default:
                        break;
                }

            }
            switch (custom?.material) {
                case "Milino":
                    materialCoef = 36;
                    break;
                case "Plywood":
                    materialCoef = 40;
                    break;
                case "Syncron":
                case "Finsa":
                    materialCoef = 48;
                    break;
                case "Luxe":
                case "Ultrapan PET":
                    materialCoef = 60;
                    break;
                case "Ultrapan Acrylic":
                    materialCoef = 60 * 1.1;
                    break;
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                    materialCoef = 60 * 1.03;
                    break;
                case "Painted":
                    materialCoef = 85.8;
                    break;
                case "Wood Veneer":
                case "StyleLite":
                    materialCoef = 99;
                    break;
            }
            price = area * materialCoef * typeCoef;
            break;
        }
        case 906: {
            const min = Math.min(width, height);
            const max = Math.max(width, height);
            const lSHapeArea = (min + depth) * max / 144
            switch (custom?.material) {
                case "Milino":
                    price = lSHapeArea * 19;
                    break
                case "Plywood":
                    price = lSHapeArea * 21;
                    break
                case "Syncron":
                case "Finsa":
                    price = lSHapeArea * 39;
                    break
                case "Luxe":
                case "Ultrapan PET":
                    price = lSHapeArea * 58;
                    break
                case "Ultrapan Acrylic":
                    price = lSHapeArea * 58 * 1.1;
                    break
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                    price = lSHapeArea * 58 * 1.03;
                    break
                case "Painted":
                    price = lSHapeArea * 82.94;
                    break
                case "Wood Veneer":
                case "StyleLite":
                    price = lSHapeArea * 110;
                    break
            }
            break
        }
        case 907: {
            const columnArea = (width * height + width * depth + height * depth) / 144 * 2 * 2.3;
            switch (custom?.material) {
                case "Milino":
                    price = columnArea * 15.2;
                    break
                case "Syncron":
                case "Finsa":
                    price = columnArea * 16.8;
                    break
                case "Luxe":
                case "Ultrapan PET":
                    price = columnArea * 18.4;
                    break
                case "Ultrapan Acrylic":
                    price = columnArea * 18.4 * 1.1;
                    break
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                    price = columnArea * 18.4 * 1.03;
                    break
                case "Painted":
                    price = columnArea * 26.31;
                    break
                case "Wood Veneer":
                case "StyleLite":
                    price = columnArea * 28.6;
                    break
            }
            break
        }
        case 909: {
            price = area * 4.6;
            break
        }
        case 910: {
            price = getShakerPanelPrice(area, custom?.material);
            break
        }
        case 911: {
            let decorPrice = area > 4 ? area * 64 : 240;
            switch (custom?.material) {
                case "Ultrapan Acrylic":
                    price = decorPrice * 1.1;
                    break;
                case "Wood Veneer":
                case "StyleLite":
                    price = area > 4 ? area * 115.5 : 240;
                    break;
                default:
                    price = decorPrice;
            }
            break
        }
        case 912: {
            price = getSlattedPanelPrice(area, custom?.material);
            break
        }
        case 913: {
            let shakerDoorPrice = area * 80 > 240 ? area * 80 : 240;
            switch (custom?.material) {
                case "Ultrapan Acrylic": {
                    price = shakerDoorPrice * 1.1;
                    break;
                }
                case "Wood Veneer":
                case "StyleLite":
                case "Painted": {
                    price = shakerDoorPrice * 1.43;
                    break;
                }
                default:
                    price = shakerDoorPrice;
            }
            break
        }
        case 914: {
            const doorProfileVal: MaybeUndefined<string> = glass?.door?.[0];
            price = addGlassDoorPrice(area, doorProfileVal, false, true);
            break;
        }
        case 915: {
            let PVCPrice = Math.ceil(width);
            switch (custom?.material) {
                case "Ultrapan Acrylic": {
                    price = PVCPrice * 1.1;
                    break;
                }
                default:
                    price = PVCPrice;
            }
            break;
        }
        case 916: {
            const glassShelf: MaybeUndefined<MaybeEmpty<GlassAndMirrorTypes>> = glass?.shelf;
            price = addGlassAndMirroredShelfPrice(area, glassShelf)
            break
        }
        case 917: {
            if (custom?.accessories?.led) price = getLEDProductCartPrice(custom.accessories.led);
            break;
        }
        case 918: {
            if (custom?.accessories?.door) price = addToCartDoorAccessories(custom.accessories.door);
            break;
        }
        case 919:
        case 920: {
            if (custom?.standard_doors) price = getCustomPartStandardDoorPrice(custom.standard_doors, type, door_color);
            break
        }
        case 921: {
            if (custom?.standard_panels) {
                const is_price_type_default = door_type === 'Standard Size Shaker' && door_color === 'Default White';
                const apiPanelData = standardProductsPrices.find(el => el.id === id) as priceStandardPanel;
                price = getStandardPanelsPrice(custom?.standard_panels, is_price_type_default, apiPanelData)
            }
            break;
        }
        case 922: {
            price = settings.fixPrices.plastic_toe;
            break;
        }
        case 923: {
            if (custom?.rta_closet) price = getRTAClosetCustomPartPrice(custom.rta_closet, materials);
            break;
        }
        case 924:
        case 925: {
            price = getCustomDoorsPrice(area, id);
            break;
        }
        case 926: {
            price = getRibbedCustomPartPrice(custom?.material, custom?.groove, area);
            break;
        }
        case 927: {
            const sq = width * depth / 144;
            const floatingShelfCustomPartPrice = getFloatingShelfCustomPartPrice(custom?.material, sq);
            const ledPrice = getLedPrice(width, height, led);
            price = floatingShelfCustomPartPrice + ledPrice;
            break;
        }
        case 928: {
            price = getDrawerInsertsCustomPartPrice(custom?.drawer_accessories?.inserts, width);
            break;
        }
        case 929: {
            price = getRoDrawerPrice(custom?.drawer_accessories?.drawer_ro, width, materials, product_id);
            break;
        }
        case 930: {
            if (custom?.painted_molding) price = 168 * custom.painted_molding;

        }
    }
    return +(price * settings.global_price_coef).toFixed(1);
}

export const addToCartDoorAccessories = (values: MaybeNull<DoorAccessoryAPIType[]>): number => {
    if (!values) return 0;
    const frontAccessories = values.map(el => (convertDoorAccessories(el)))
    return +(frontAccessories.reduce((acc, item) => acc + (item.price * item.qty), 0)).toFixed(1)
}

export const getCustomPartStandardDoorPrice = (doors: MaybeNull<StandardDoorAPIType[]>, name: CustomTypes, color: string): number => {
    if (!doors) return 0;
    const glassPrice: number = name !== 'standard-doors' ? settings.standard_glass_door_price : 0;
    const colorPrice: number = color !== 'Default White' ? settings.standard_glass_door_color_coef : 0;
    return doors.reduce((acc, door) => {
        const sqr = door.width * door.height / 144;
        const doorPrice = sqr * (20 + glassPrice + colorPrice);
        return +(acc + (doorPrice * door.qty)).toFixed(1)
    }, 0);
}


export const getStandardPanelsPrice = (standard_panels: PanelsFormAPIType, is_price_type_default: boolean, apiPanelData: priceStandardPanel): number => {
    const {standard_panel = [], shape_panel = [], wtk = [], crown_molding = 0} = standard_panels;

    const standard_panel_price = standard_panel.reduce((acc, panel) => {
        const panelPriceData = apiPanelData.standard_panel.find(el => el.name === panel.name);
        if (!panelPriceData) return 0;
        return acc + ((is_price_type_default ? panelPriceData.price : panelPriceData.painted_price) * panel.qty)
    }, 0);

    const shape_panel_price = shape_panel.reduce((acc, panel) => {
        const panelPriceData = apiPanelData.shape_panel.find(el => el.name === panel.name);
        if (!panelPriceData) return 0;
        return acc + ((is_price_type_default ? panelPriceData.price : panelPriceData.painted_price) * panel.qty)
    }, 0);

    const wtk_price = wtk.reduce((acc, panel) => {
        const panelPriceData = apiPanelData.wtk.find(el => el.name === panel.name);
        if (!panelPriceData) return 0;
        return acc + ((is_price_type_default ? panelPriceData.price : panelPriceData.painted_price) * panel.qty)
    }, 0);


    const crown_molding_item_price: number = is_price_type_default ? settings.crown_molding_price[0] : settings.crown_molding_price[1]
    const crown_price = crown_molding_item_price * crown_molding;

    return standard_panel_price + shape_panel_price + wtk_price + crown_price;
}

const getRodsQty = (attrArr: { name: string, value: number }[]): number => {
    return attrArr.find(el => el.name.includes('Hanging Rod'))?.value ?? 0;
}
export const calculateCartPriceAfterMaterialsChange = (cart: CartItemFrontType[], materials: RoomMaterialsFormType): CartItemFrontType[] => {
    return cart.map(cartItem => {
        const {product_id, product_type} = cartItem;
        const product_or_custom = getProductById(product_id, product_type === 'standard');
        if (!product_or_custom) return cartItem;
        if (product_type === 'custom') return cartItem;
        const product = product_or_custom as unknown as ProductType;
        const materialData = getMaterialData(materials, product_id)
        const tablePriceData = getProductPriceRange(product_id, materialData);
        if (!tablePriceData) return cartItem;
        const sizeLimit: MaybeUndefined<sizeLimitsType> = sizes.find(size => size.productIds.includes(product_id))?.limits;
        if (!sizeLimit) return cartItem;
        const totalPrice = calculateProduct(cartItem, materialData, tablePriceData, sizeLimit, product);
        return {...cartItem, price: totalPrice};
    });
}

export const calculateProduct = (cabinetItem: CartAPI, materialData: materialDataType, tablePriceData: pricePart[], sizeLimit: sizeLimitsType, product: ProductType): number => {
    const {attributes} = product
    const {width, height, depth, options} = cabinetItem;
    const image_active_number = resolveTypeByDimensions(attributes, width, height);
    const tablePrice = getTablePrice(width, height, depth, tablePriceData);
    console.log('------------------------------')
    console.log(`tablePrice ${tablePrice}`)
    const isSizeValid = checkProductSize(width, height, depth, sizeLimit, tablePrice);
    if (!isSizeValid) return 0;
    const startPrice = getStartPrice(tablePrice, materialData, options);
    const size_coef = getSizeCoef(cabinetItem, tablePriceData, product);
    console.log(`size_coef ${size_coef}`)
    const attributesPrices = getAttributesProductPrices(cabinetItem, product, materialData, image_active_number);
    const attrPrice = Object.values(attributesPrices).reduce((partialSum, a) => partialSum + a, 0);
    const totalPrice = +(startPrice * size_coef + attrPrice).toFixed(1);
    return totalPrice * settings.global_price_coef
}

const checkProductSize = (customWidth: number, customHeight: number, customDepth: number, sizeLimit: sizeLimitsType, tablePrice: number): boolean => {
    const settingMinWidth = sizeLimit.width[0];
    const settingMaxWidth = sizeLimit.width[1];
    const settingMinHeight = sizeLimit.height[0];
    const settingMaxHeight = sizeLimit.height[1];
    const settingMinDepth = sizeLimit.depth[0];
    const settingMaxDepth = sizeLimit.depth[1];
    const isFitMinMaxWidth = (customWidth >= settingMinWidth) && (customWidth <= settingMaxWidth);
    const isFitMinMaxHeight = (customHeight >= settingMinHeight) && (customHeight <= settingMaxHeight);
    const isFitMinMaxDepth = (customDepth >= settingMinDepth) && (customDepth <= settingMaxDepth);
    return !(!isFitMinMaxWidth || !isFitMinMaxHeight || !isFitMinMaxDepth || !tablePrice);
}

const getAttributesProductPrices = (cart: CartAPI, product: ProductType, materialData: materialDataType, image_active_number: productTypings): AttributesPrices => {
    const {
        legsHeight = 0,
        isAngle,
        category,
        id,
        product_type,
        hasMechanism,
        hasExtraRolloutsBlock
    } = product;
    const {
        options,
        width,
        height,
        depth,
        blind_width,
        middle_section,
        led,
        glass,
        custom,
        hinge,
        finish_sides
    } = cart;
    const {
        drawer_brand,
        drawer_type,
        drawer_color,
        door_type,
        door_finish_material,
        category: room_category,
        rod
    } = materialData;

    const productPriceData = getProductDataToCalculatePrice(product, materialData, image_active_number);
    const {drawersQty, shelfsQty, rodsQty} = productPriceData;

    const doorWidth = getWidthToCalculateDoor(width, blind_width, isAngle, category)
    const doorHeight = getDoorHeight(product, cart);
    const frontSquare = getSquare(doorWidth, doorHeight, id);
    const hasGlassDoor = options.includes('Glass Door');
    const glassDoorProfile = glass?.door ? glass.door[0] : undefined;
    const shelfArea = (width * depth / 144) * shelfsQty;
    const finishSidesMaterial = door_type === 'Custom Painted' ? 'Painted' : door_finish_material;
    const led_width = getLedWidth(width, rodsQty);
    const led_height = getLedHeight(height, id);
    const pvcPrice = getPvcPrice(doorWidth, doorHeight, product, materialData);
    const doorPrice = getDoorPrice(frontSquare, materialData);
    const drawerPrice = getDrawerPrice(drawersQty, doorWidth, door_type, drawer_brand, drawer_type, drawer_color)
    const finish_sidesPrice = finish_sides?.length ? getFinishSidesPrice(finish_sides, doorWidth, height - legsHeight, depth, finishSidesMaterial) : 0


    console.log(`doorWidth ${doorWidth}`)
    console.log(`doorHeight ${doorHeight}`)
    console.log(`frontSquare ${frontSquare}`)
    console.log(`pvcPrice ${pvcPrice}`)
    console.log(`doorPrice ${doorPrice}`)
    console.log(`drawerPrice ${drawerPrice}`)
    console.log(`finishSidesPrice ${finish_sidesPrice}`)
    return {
        ptoDoors: options.includes('PTO for doors') ? addPTODoorsPrice(hinge, id, room_category, doorWidth) : 0,
        ptoDrawers: options.includes('PTO for drawers') ? addPTODrawerPrice(image_active_number, drawersQty) : 0,
        glassShelf: options.includes('Glass Shelf') ? addGlassAndMirroredShelfPrice(shelfArea, glass?.shelf) : 0,
        ptoTrashBins: options.includes('Servo-Drive') ? addPTOTrashBinsPrice() : 0,

        pvcPrice,
        doorPrice,
        drawerPrice,
        ledPrice: getLedPrice(led_width, led_height, led),
        glassDoor: addGlassDoorPrice(frontSquare, glassDoorProfile, product_type === "standard", hasGlassDoor),
        closetAccessoriesPrice: getClosetAccessoriesPrice(custom?.accessories?.closet, width),
        jeweleryInsertsPrice: getJeweleryInsertsPrice(custom?.jewelery_inserts),
        mechanismPrice: getMechanismPrice(custom?.mechanism, hasMechanism),
        rodPrice: getRodPrice(room_category, width, rod, rodsQty) / settings.global_price_coef,
        extra_rollouts: getExtraRolloutsPrice(hasExtraRolloutsBlock, cart, materialData),
        finish_sides: finish_sidesPrice
    }
}
const getSizeCoef = (cartItem: CartAPI, tablePriceData: pricePart[], product: ProductType): number => {
    const {category, isAngle, customHeight, customDepth} = product
    const {width, height, depth} = cartItem
    const productRange = getProductRange(tablePriceData, category, customHeight, customDepth);
    const {widthRange, heightRange, depthRange} = productRange
    let coef_w, coef_h, coef_d;
    coef_w = coef_h = coef_d = 0;
    const maxWidth = widthRange[widthRange.length - 1];
    const maxHeight = heightRange[heightRange.length - 1];
    if (maxWidth < width) coef_w = addWidthPriceCoef(width, maxWidth);
    if (maxHeight < height) coef_h = addHeightPriceCoef(height, maxHeight);
    if (depthRange[0] !== depth) coef_d = addDepthPriceCoef(depth, depthRange, isAngle);
    return 1 + (coef_w + coef_h + coef_d)
}

export const getRTAClosetCustomPartPrice = (rta_closet_custom: MaybeNull<RTAClosetAPIType[]>, materials: RoomMaterialsFormType): number => {
    if (!rta_closet_custom) return 0;
    const getItemPrice = (item: RTAClosetAPIType): number => {
        const {name, qty, width} = item;
        if (!qty || !name || !width) return 0;
        const getCoef = (materials: RoomMaterialsFormType): number => {
            const {box_material, box_color} = materials
            switch (box_material) {
                case "Milino":
                    const boxType = getBoxMaterialColorType(box_color)
                    if (boxType === 1) return 8;
                    if (boxType === 2) return 8.8;
                    if (boxType === 3) return 9.6;
                    return 9.2;
                case "Syncron":
                case "Finsa":
                    return 18;
                case "Luxe":
                case "Zenit":
                case "OneSkin":
                case "Egger":
                case "Cleaf":
                case "Ultrapan PET":
                    return 24;
                case "Ultrapan Acrylic":
                case "StyleLite":
                    return 26.4;
                default:
                    return 0;
            }
        }
        const coef = getCoef(materials);
        switch (name) {
            case "SR":
                return width * 15 / 12;
            case "STK":
                return 1 + (width * 3 * coef) / 144;
            case "AS14":
                return width * 14 * coef / 144;
            case "AS18":
                return width * 18 * coef / 144;
            case "AS22":
                return width * 22 * coef / 144;
            case "FS14":
                return 5 + (width * 14 * coef) / 144
            case "FS18":
                return 5 + (width * 18 * coef) / 144
            case "FS22":
                return 5 + (width * 22 * coef) / 144
            case "SS14":
                return width + (width * 14 * coef) / 144
            case "SS18":
                return width + (width * 18 * coef) / 144
            case "SS22":
                return width + (width * 22 * coef) / 144;
            default:
                return 0
        }
    }
    return +(rta_closet_custom.reduce((acc, item) => acc + (getItemPrice(item) * item.qty), 0)).toFixed(2)
}

export const getCustomDoorsPrice = (area: number, id: number): number => {
    const coef = id === 924 ? 78 : 104
    return +(area * coef).toFixed(1);
}

export const getRibbedCustomPartPrice = (material: MaybeUndefined<string>, groove: MaybeUndefined<GrooveAPIType>, area: number): number => {
    const clearCoatPrice = groove?.clear_coat ? settings.fixPrices.clear_coat : 0;
    switch (material) {
        case "Painted":
            return area * (85.8 + clearCoatPrice)
        case "Maple":
        case "Birch":
            return area * (145 + clearCoatPrice)
        case "White Oak":
        case "Walnut":
            return area * (225 + clearCoatPrice)
    }
    return 0
}

export const getFloatingShelfCustomPartPrice = (material: MaybeUndefined<string>, area: number): number => {
    switch (material) {
        case "Milino":
            return area * 72;
        case "Syncron":
        case "Finsa":
            return area * 86.4;
        case "Luxe":
        case "Ultrapan PET":
            return area * 102;
        case "Zenit":
        case "OneSkin":
        case "Egger":
        case "Cleaf":
            return area * 102 * 1.03;
        case "Ultrapan Acrylic":
            return area * 102 * 1.1;
        case "Painted":
            return area * 145.9;
        case "Wood Veneer":
        case "StyleLite":
            return area * 168.3;
    }
    return 0
}

export const getDrawerInsertsCustomPartPrice = (inserts: MaybeUndefined<DrawerInserts>, width: number): number => {
    if (!inserts || !width) return 0;
    const {box_type, color} = inserts;
    if (!color) return 0;
    // let colorCoef: number = 0;
    switch (box_type) {
        case "Inserts":
            // colorCoef = color === 'Maple' ? 5 : 9;
            if (width <= 12) return color === "Maple" ? 84 : 151;
            if (width <= 15) return color === "Maple" ? 105 : 189;
            if (width <= 18) return color === "Maple" ? 126 : 227;
            if (width <= 21) return color === "Maple" ? 147 : 265;
            if (width <= 24) return color === "Maple" ? 168 : 302;
            if (width <= 27) return color === "Maple" ? 189 : 340;
            if (width <= 30) return color === "Maple" ? 210 : 378;
            if (width <= 33) return color === "Maple" ? 231 : 416;
            if (width <= 36) return color === "Maple" ? 252 : 454;
            return color === "Maple" ? 273 : 491;
        case "Pegs":
            // colorCoef = color === 'Maple' ? 4 : 8;
            if (width <= 24) return color === "Maple" ? 134 : 269;
            if (width <= 27) return color === "Maple" ? 151 : 302;
            if (width <= 30) return color === "Maple" ? 168 : 336;
            if (width <= 33) return color === "Maple" ? 185 : 370;
            if (width <= 36) return color === "Maple" ? 202 : 403;
            return color === "Maple" ? 218 : 437;
        case "Spice":
            // colorCoef = color === 'Maple' ? 4 : 5;
            if (width <= 12) return color === "Maple" ? 67 : 84;
            if (width <= 15) return color === "Maple" ? 84 : 105;
            if (width <= 18) return color === "Maple" ? 101 : 126;
            if (width <= 21) return color === "Maple" ? 118 : 147;
            if (width <= 24) return color === "Maple" ? 134 : 168;
            if (width <= 27) return color === "Maple" ? 151 : 189;
            if (width <= 30) return color === "Maple" ? 168 : 210;
            if (width <= 33) return color === "Maple" ? 185 : 231;
            if (width <= 36) return color === "Maple" ? 202 : 252;
            return color === "Maple" ? 218 : 273;

    }
    // return Math.round(width * colorCoef * 1.4);
}

const getRoDrawerTablePrice = (width: number, basePriceType: pricesTypings, ro_drawer: DrawerROType): number => {
    if (basePriceType === 'wood_veneer') return 0;
    type PriceType = {
        "width": number,
        "Extra RO": number,
        "Drawer": number
    }

    interface PriceTypeArrayItem {
        type: pricesTypingsNumber
        prices: PriceType[],
    }

    const arr = ro_drawer_prices as PriceTypeArrayItem[];
    const prices = arr.find(el => el.type === basePriceType)?.prices;
    if (!prices) return 0;
    if (width < prices[0].width) return prices[0][ro_drawer];
    const maxData = prices[prices.length - 1];
    if (width > maxData.width) {
        // size coef
        const w_coef = 1 + addWidthPriceCoef(width, maxData.width);
        return maxData[ro_drawer] * w_coef;
    }
    return prices.find((el, index) => el[ro_drawer] && (el.width >= width))?.[ro_drawer] || 0;
}

export const getRoDrawerPrice = (ro_drawer: MaybeUndefined<DrawerROType>, width: number, materials: RoomMaterialsFormType, product_id: number): number => {
    if (!ro_drawer || !width) return 0;
    const {drawer_type, drawer_color, drawer_brand, door_type} = materials
    const basePriceType = getBasePriceType(materials);
    const materialData = getMaterialData(materials, product_id);
    const tablePrice = getRoDrawerTablePrice(width, basePriceType, ro_drawer);
    const startPrice = getStartPrice(tablePrice, materialData, [])
    const drawerPrice = getDrawerPrice(1, width, door_type, drawer_brand, drawer_type, drawer_color);
    if (ro_drawer === 'Extra RO') return startPrice + drawerPrice;
    const sq = getSquare(width, 6, product_id);
    const doorPrice = getDoorPrice(sq, materialData);
    return startPrice + drawerPrice + doorPrice;
}